module.exports = __webpack_public_path__ + "img/invoiceBack.df0e82fe.png";